import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
export const LOGO_LINK = {
  [PREDEFINED_TENANTS.SWAG]: 'https://swag.com/assets/img/swag-logo-blue.jpg',
  [PREDEFINED_TENANTS.SENDOSO]: 'https://swag-prod.s3.us-east-2.amazonaws.com/emails/swag-prod/assets/img/sendoso.png',
  [PREDEFINED_TENANTS.POSTAL]: 'https://swag-prod.s3.us-east-2.amazonaws.com/emails/swag-prod/assets/img/logo-postal.png',
  [PREDEFINED_TENANTS.CUSTOM_INK]: 'https://swag-prod.s3.us-east-2.amazonaws.com/images/custom-ink-logo.png'
};